import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { PaymentMethod, Product, RelatedCard } from '../ridango.models';

@Injectable({ providedIn: 'root' })
export class PaymentDataService {
    private priceSubject = new BehaviorSubject<Product | null>(null);
    private cardSubject = new BehaviorSubject<RelatedCard | null>(null);
    private selectedPaymentMethodSubject = new BehaviorSubject<PaymentMethod | null>(null);
    private ticketCreationErrorSubject = new BehaviorSubject<boolean>(false);

    price$ = this.priceSubject.asObservable();
    cardNumber$ = this.cardSubject.asObservable();
    selectedPaymentMethod$ = this.selectedPaymentMethodSubject.asObservable();
    ticketCreationError$ = this.ticketCreationErrorSubject.asObservable();

    setProduct(value: Product) {
        this.priceSubject.next(value);
    }

    getProduct(): Product | null {
        return this.priceSubject.value;
    }

    setCard(card: RelatedCard) {
        this.cardSubject.next(card);
    }

    getCard(): RelatedCard | null {
        return this.cardSubject.value;
    }

    setSelectedPaymentMethod(method: PaymentMethod) {
        this.selectedPaymentMethodSubject.next(method);
    }

    getSelectedPaymentMethod(): PaymentMethod | null {
        return this.selectedPaymentMethodSubject.value;
    }

    setTicketCreationError(hasError: boolean) {
        this.ticketCreationErrorSubject.next(hasError);
    }

    resetData() {
        this.priceSubject.next(null);
        this.cardSubject.next(null);
        this.selectedPaymentMethodSubject.next(null);
    }
}
